/**
 * Create/Update Address Form Utilities
 * Transform form data to GraphQL input variables
 * @see mobile: module-customer/src/modules/addresses/utils/create-update-address-form.utils.ts
 */

import {
    CountryCodeEnum,
    type AddressTypeEnum,
    type CustomerAddress,
    type CustomerAddressInput,
    type InputMaybe,
} from '../../../types/front.graphql';
import type { AddressFormType } from '../components/address-form';

const getNameByData = (data: AddressFormType) => {
    const nameParts = data?.name?.split(' ') ?? [];
    const firstName = nameParts[0] && nameParts[0] !== '' ? nameParts?.[0] : ' ';
    const lastName = nameParts?.length > 1 ? nameParts?.slice(1).join(' ') : firstName;

    return {
        firstName,
        lastName,
    };
};

const getStreetByData = (data: AddressFormType) => {
    const street = data?.street;
    if (!street) return undefined;

    const streetArray = Array.isArray(street) ? street : [street];
    const parts = streetArray.map(part => part.trim()).filter(part => part !== '');
    return parts.length > 0 ? parts : undefined;
};

export const getInputVariable = (
    data: AddressFormType,
    shippingAddress?: CustomerAddress
): InputMaybe<CustomerAddressInput> => {
    const { firstName, lastName } = getNameByData(data);
    const input: InputMaybe<CustomerAddressInput> = {
        firstname: firstName,
        lastname: lastName,
        telephone: data?.phoneNumber,
        street: getStreetByData(data),
        city: data?.location?.region?.name,
        region: {
            region_code: data?.location?.region?.code,
            region_id: Number.parseInt(data?.location?.region?.id, 10),
            region: data?.location?.region?.name,
        },
        district_id: Number.parseInt(data?.location?.district?.id, 10),
        district: data?.location?.district?.name,
        ward_id: Number.parseInt(data?.location?.ward?.id, 10),
        ward: data?.location?.ward?.name,
        default_shipping: data?.defaultAddress,
        country_code: CountryCodeEnum.Vn,
        address_type: data?.addressType as AddressTypeEnum,
        default_billing: data?.defaultAddress,
    };
    if (!shippingAddress?.id) {
        input.city = data?.location?.region?.name;
    }

    return input;
};
